import { defaultSchema } from 'rehype-sanitize';

const dedupe = (values = []) => Array.from(new Set(values));
const extend = (collection, tag, additions) => {
  collection[tag] = dedupe([...(collection[tag] || []), ...additions]);
};

const attributeTargets = ['*', 'span', 'mark', 'p', 'strong', 'em', 'div', 'section', 'article', 'ul', 'ol', 'li', 'blockquote', 'code'];
const propertyTargets = ['*', 'span', 'mark', 'p', 'strong', 'em', 'div', 'section', 'article', 'ul', 'ol', 'li', 'blockquote', 'code'];

const attributes = { ...defaultSchema.attributes };
attributeTargets.forEach((tag) => extend(attributes, tag, ['style', 'className', 'class']));
extend(attributes, 'font', ['color', 'style', 'className', 'class']);

const properties = { ...defaultSchema.properties };
propertyTargets.forEach((tag) => extend(properties, tag, ['style', 'className']));
extend(properties, 'font', ['color', 'style', 'className']);

const styles = dedupe([
  ...(defaultSchema.styles || []),
  'color',
  'background',
  'background-color',
  'background-image',
  'background-size',
  'font-weight',
  'font-style',
  'font-size',
  'line-height',
  'letter-spacing',
  'text-align',
  'text-decoration',
  'text-decoration-color',
  'text-decoration-line',
  'border',
  'border-color',
  'border-style',
  'border-width',
  'border-radius',
  'box-shadow',
  'padding',
  'padding-left',
  'padding-right',
  'padding-top',
  'padding-bottom',
  'margin',
  'margin-left',
  'margin-right',
  'margin-top',
  'margin-bottom',
  'white-space',
  'display',
]);

export const markdownSanitizeOptions = {
  ...defaultSchema,
  attributes,
  properties,
  styles,
};
